import { render } from "./CameraPreviewComponent.vue?vue&type=template&id=3065c42f&scoped=true"
import script from "./CameraPreviewComponent.vue?vue&type=script&lang=js"
export * from "./CameraPreviewComponent.vue?vue&type=script&lang=js"

import "./CameraPreviewComponent.vue?vue&type=style&index=0&id=3065c42f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3065c42f"]])

export default __exports__